import * as yup from 'yup';

export const individual_client_classification_validation_schema = yup.object().shape({

  clientClassificationAnyEntityCriterias: yup
    .array()
    .required('this_field_is_required')
    .min(1, 'this_field_is_required'),

  agreeToTermsAndCondition: yup
    .boolean()
    .oneOf([true], 'must_agree_terms_condition'),

});
